import React, { useEffect } from "react";
import { Container } from "react-bootstrap";
import { Route, Routes, useLocation } from "react-router-dom";

// Components
import {
  Footer,
  IconHeader,
  Logo,
  // Navigation,
  ToastComponent,
} from "./Components";
// Store
import { pathTitles, useStore } from "./Store/Store";
import { About, ContactUs, FAQ, Home, Testimonials, Training } from "./Views";

function App() {
  const getLink = useStore((state) => state.getLink);
  const checkServices = useStore((state) => state.checkServices);
  const trainingDetails = useStore((state) => state.trainingDetails);
  const getWindow = useStore((state) => state.getWindow);
  useEffect(() => {
    checkServices(trainingDetails);
    getWindow();
  }, []);

  let location = useLocation();
  let show = true;
  if (location.pathname !== "/") show = false;
  return (
    <>
      <div id="blue_ink" className="wrapper bg-image">
        <ToastComponent />
        <IconHeader top_or_bottom="top" showLogo={!show} />
        {show && <Logo />}
        <div className="content-page">
          <Container fluid className="no-gutters main_container">
            {/* <span className="no_show_elm navigation_component">
              <Navigation mobile={false} expand={true} />
            </span> */}
            <Routes>
              <Route path="/" element={<Home />} />
              <Route
                path={`${getLink(pathTitles.TRAINING)}/*`}
                element={<Training />}
              />
              <Route
                path={`${getLink(pathTitles.MEETTHETEAM)}/*`}
                element={<About />}
              />
              <Route
                path={getLink(pathTitles.CONTACTUS)}
                element={<ContactUs />}
              />
              <Route
                path={getLink(pathTitles.TESTIMONIALS)}
                element={<Testimonials />}
              />
              <Route path={getLink(pathTitles.FAQ)} element={<FAQ />} />
            </Routes>
          </Container>
        </div>
      </div>
      <Footer />
    </>
  );
}

export default App;
